export const permissionKeys = {
  Dashboard: "dashboard",
  LiveMonitor: "live-monitor",
  Dialpad: "dialpad",
  Team: "team",
  Campaigns: "campaigns",

  // ? MESSAGE
  SmsDashboard: "sms-dashboard",
  SmsTemplate: "sms-template",
  SmsProvider: "sms-provider",
  SmppProvider: "smpp-provider",
  SmsSender: "sms-sender",
  SmsReport: "sms-report",
  EmailTemplate: "email-template",
  EmailProvider: "email-provider",
  EmailReport: "email-report",
  RcsDashboard: "rcs-dashboard",
  RcsProvider: "rcs-provider",
  RcsReport: "rcs-report",
  WhatsappDashboard: "whatsapp-dashboard",
  WhatsappProvider: "whatsapp-provider",
  WhatsappTemplate: "whatsapp-template",
  WhatsappReport: "whatsapp-report",
  WhatsappNumber: "whatsapp-number",
  NlpDashboard: "nlp-dashboard",
  NlpAgent: "nlp-agent",

  // ? REPORTS
  VoiceCdrReport: "voice-cdr-report",
  OutboundCdrReport: "outbound-cdr-report",
  InboundCdrReport: "inbound-cdr-report",
  DncCdrReport: "dnc-cdr-report",
  AgentOutboundCdrReport: "agent-outbound-cdr-report",
  AgentInboundCdrReport: "agent-inbound-cdr-report",
  AgentOutboundDropReport: "agent-outbound-drop-report",
  AgentInboundMissedReport: "agent-inbound-missed-report",
  UserSummaryReport: "user-summary-report",
  BreakSummaryReport: "break-summary-report",
  DisposeSummaryReport: "dispose-summary-report",
  CallbackReport: "callback-report",
  TeamSummaryReport: "team-summary-report",
  CampaignSummaryReport: "campaign-summary-report",
  AutoDisposeSummaryReport: "auto-dispose-summary-report",
  AgentHeatMapReport: "agent-heat-map-report",
  LeadStatusReport: "lead-status-report",
  ContactListCallStatisticsReport: "contact-list-call-statistics-report",
  ContactListQualityAssuranceReport: "contact-list-quality-assurance-report",
  DuplicateLeadIdentificationReport: "duplicate-lead-identification-report",
  BroadcastCdrReport: "broadcast-cdr-report",
  CpassOutboundCdrReport: "cpass-outbound-cdr-report",
  CpassInboundCdrReport: "cpass-inbound-cdr-report",
  WebhookReport: "webhook-report",

  // ? SETTING
  User: "user",
  SkillMapping: "skill-mapping",
  Skill: "skill",
  Permission: "permission",
  MissedCallToCampaign: "missed-call-to-campaign",
  PhoneNumber: "phone-number",
  Provider: "provider",
  Country: "country",
  CarrierRate: "carrier-rate",
  Integration: "integration",
  LeadsquaredIntegration: "leadsquared-integration",
  SalesforceIntegration: "salesforce-integration",
  ZohoCrmIntegration: "zoho-crm-integration",
  WebhookIntegration: "webhook-integration",
  PopupIntegration: "popup-integration",
  GuideWireIntegration: "guidewire-integration",
  Disposition: "disposition",
  Contact: "contact",
  Sound: "sound",
  Break: "break",
  Dnc: "dnc",
  Holiday: "holiday",
  Flow: "flow",
  ImportExport: "import-export",
  Logs: "logs",
  Account: "account",
  Region: "region",
  PlansAndBilling: "plans-and-billing",
};



// WEBPACK FOOTER //
// src/modules/common/utils/Permission/Keys.js